module.exports = __webpack_public_path__ + "static/media/logo-mark.20ee5577.svg";